import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    minHeight: 240,
  },
  root: {
    marginTop: 0,
    marginBottom: 0,
  },
  listItem: {
    fontSize: theme.typography.pxToRem(14),
  },
  aggregateTitle: {
    minWidth: 150,
    textAlign: 'left',
    width: '30%',
    maxWidth: 250,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    '@media (max-width:1300px)': {
      maxWidth: 160,
    },

    '@media (max-width:1220px)': {
      maxWidth: 150,
    },
  },
  box: {
    borderColor: '#E4E4E4',
    borderRadius: 0,
    borderWidth: '0 1px 1px 1px',
    marginBottom: 15,
    marginTop: 0,
    padding: 0,
  },
  aggregatesContainer: {
    marginBottom: 5,
  },
  buttonClass: {
    backgroundColor: '#fff',
    border: '1px solid #E4E4E4',
    borderRadius: 0,
    boxShadow: '0px 3px 6px #00000019',
    color: '#2C2C2E',
    fontWeight: 'bold',
    fontSize: '13px',
    padding: '10px 24px',
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: '#fff',
      boxShadow: '0px 3px 6px #00000019',
    },
  },
  buttonClassExtended: {
    borderRadius: '4px 4px 0 0 !important',
    backgroundColor: '#FBFBFB',
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#FBFBFB',
      boxShadow: 'none',
    },
  },
  statisticContainer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginLeft: 40,
    minWidth: 80,

    '@media (max-width:1200px)': {
      marginLeft: 0,
      marginRight: 20,
    },
  },
  statisticIcon: {
    alignItems: 'center',
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    height: 24,
    width: 24,
    '& svg': {
      fontSize: 12,
    },
  },
  online: {
    borderColor: theme.palette.success.main,
    color: theme.palette.success.main,
  },
  reserved: {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
  },
  offline: {
    borderColor: theme.palette.warning.main,
    color: theme.palette.warning.main,
  },
  late: {
    borderColor: theme.palette.error.main,
    color: theme.palette.error.main,
  },
  calendarSidebar: {
    borderRight: '1px solid #E0E0E0',
  },
  calendarContainer: {
    boxShadow: '0px 3px 6px #00000019',
    '& .rct-header-root': {
      backgroundColor: '#FFF',
      border: '0',

      '& .rct-calendar-header': {
        border: 0,
        color: theme.palette.text.primary,

        '& div:first-child': {
          '& .rct-dateHeader': {
            backgroundColor: '#FFF',
            borderBottom: '1px solid #E0E0E0',
          },
        },
        '& div:last-child': {
          '& .rct-dateHeader': {
            backgroundColor: '#FFF',
            borderBottom: 'none',
            borderLeft: '1px solid #E0E0E0',
          },
        },
      },
    },
    '& .rct-outer': {
      backgroundColor: '#FFF',
      borderColor: '#E0E0E0',
      borderWidth: '1px 1px 1px 0px',
      height: 35,
      '& .rct-sidebar': {
        border: 'none',
        color: theme.palette.text.primary,

        '& .rct-sidebar-row': {
          backgroundColor: '#FFF',
          borderColor: '#E0E0E0',
          borderRight: '1px solid #E0E0E0',
          color: theme.palette.text.primary,
          fontSize: theme.typography.pxToRem(13),
          textAlign: 'center',
        },
      },
    },
  },
  itemPopup: {
    position: 'relative',
  },
  itemPopupContainer: {
    left: 10,
    position: 'absolute',
    top: -24,
  },
  itemPopupArrow: {
    boxShadow: '0 16px 10px -17px rgba(0, 0, 0, 0.5)',
    height: 25,
    overflow: 'hidden',
    position: 'relative',
    width: 25,
    zIndex: 1000,
    '&::after': {
      background: '#FFF',
      boxShadow: '-1px -1px 10px -2px rgba(0, 0, 0, 0.5)',
      content: "''",
      height: 12.5,
      left: 6.25,
      position: 'absolute',
      top: 18.75,
      transform: 'rotate(45deg)',
      width: 12.5,
    },
  },
  subheader: {
    minHeight: 75,
    padding: '24px 32px',
  },
  lastFetched: {
    textTransform: 'capitalize',
  },
  switch: {
    '& .MuiFormControlLabel-label': {
      fontSize: theme.typography.pxToRem(14),
    },
  },
  searchIcon: {
    color: theme.palette.text.primary,
    fontSize: theme.typography.pxToRem(16),
  },
  popupTitle: {
    textTransform: 'capitalize',
  },
}));

export { useStyles };
